import { appContext } from "ui-common/appContext";
import { queryOptions } from "ui-common/query-options";
import { rpc } from "ui-common/services/rpc";

export const profileDataQueryOptions = queryOptions({
  queryKey: ["profileData"],
  queryFn: async () => {
    await appContext.ready;
    if (!appContext.isAuthenticated) return null;
    return rpc("profileData", undefined);
  },
});
